import { Image } from "antd";
import { useRedEnvelope } from "../../../../context/RedEnvelopeContext";
import { envChangeType } from "../../../../plugins/utils";
import styles from "./style.module.scss";
import "./style.scss";

const RedEnvelope = () => {
  const { setShowRedEnvelopePopup } = useRedEnvelope();
  const handleOpenRedEnvelope = () => {
    setShowRedEnvelopePopup(true);
  };

  return (
    <div onClick={handleOpenRedEnvelope} className={`${styles.redEnvelope} `}>
      <Image
        src={`/images/redEnvelope/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/red.webp`}
        fallback="/images/redEnvelope//red.webp"
        alt="red_envelope"
        className={styles.envelope}
        preview={false}
        draggable={false}
      />
      {/* <RedEnvelopePopup
        bonusAmount={bonusAmount}
        showRedEnvelopePopup={showRedEnvelopePopup}
        setShowRedEnvelopePopup={setShowRedEnvelopePopup}
      /> */}
    </div>
  );
};

export default RedEnvelope;
